import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class UniversityOfMadrasDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <h1 style={{fontSize: '30px'}}>UG / PG correspondence courses in chennai</h1>
				  <p><b>University of Madras :</b> A Public State University which is ranked in the Best Global Universities list and stands prestigious in Chennai. MIET helps you to crack the distance education courses offered by this University. </p>
				  
                  </ScrollAnimation>
                  
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<h5 className="mb-0 mt-2">Courses Offered: </h5>
                            <p>UG Programmes:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Tamil
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Literature in Tamil
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. French 
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. English
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Economics 
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Historical Studies
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Sociology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Public Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.A. Criminology and Police Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Com
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Com. Corporate Secretaryship
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Com. Bank Management
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Com. Computer Applications
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.B.A. - [Bachelor of Business Administration]
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Mathematics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Psychology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.Sc. Geography
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.C.A. - [Bachelor of Computer Applications]
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />B.F.A. [Music]
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							{/* <h5 className="mb-0 mt-2">Courses Offered: </h5> */}
                            <p>PG Programmes:</p>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Tamil
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. English
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Economics
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Christian Studies
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Historical Studies
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Sociology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Political Science
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Sanskrit
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Applied Saiva Siddhanta
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Public Administration
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Human Rights and Duties Education
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.A. Journalism
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Com
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Mathematics
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Psychology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Counselling Psychology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Cyber Forensics and Information Security
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Geography
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.Sc. Information Technology
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.C.A. - [Master of Computer Applications]
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />M.F.A. [Music]
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>	
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>				
				  </div>
		      </div>
			  <Sidebar courseRestriction="University of Madras"/>
		    </div>
		  </div>
		</div>

        }
}

export default UniversityOfMadrasDetails